import { Typography } from "@material-ui/core";
import { ifElse } from "ramda";
import { memo } from "react";

import { Grid } from "../../../components/Grid";

import style from "./SummaryRow.module.scss";

type SummaryRowProps = {
  name: string;
  value: string | string[] | null;
};

const parseContent = (values: string[]) =>
  values.map((value: string, index) => (
    <a
      key={value}
      className={style["value-item"]}
      href={value}
      target="_blank"
      rel="noreferrer"
    >
      Załącznik {++index}
    </a>
  ));
const renderRowContent = ifElse(
  (value) => Array.isArray(value),
  parseContent,
  (value) => value
);

export const SummaryRow = memo<SummaryRowProps>(({ name, value }) => (
  <Grid container className={style.container}>
    <Grid item xs={12} md={4} spacingInnerRight={5}>
      <Typography>{name}</Typography>
    </Grid>
    <Grid item className={style["value-container"]} xs={12} md={8}>
      <Typography>{renderRowContent(value)}</Typography>
    </Grid>
  </Grid>
));
